<!--
 * @Author: xuquantong
 * @Date: 2022-07-05 15:17:12
 * @LastEditors: tianyuhan
 * @LastEditTime: 2023-07-26 17:31:33
 * @Description: 一分团步骤说明
-->
<template>
  <div class="group-rundown">
    <div
      class="container"
      @click="showGroup"
      tabindex="0"
      v-track="[
        {
          act: 'show',
          params: {
            cfrom: '081|063|02|077',
            event_id: '081|063|02|077',
            goodtype: goodsType,
            goodid: skuId,
            module: 2,
            pagetype: 0
          }
        },
        {
          act: 'click',
          params: {
            cfrom: '081|063|01|077',
            event_id: '081|063|01|077',
            goodtype: goodsType,
            goodid: skuId,
            module: 2,
            pagetype: 0
          }
        }
      ]"
    >
      <div class="leftrun">
        <div class="title">玩法</div>
        <div class="run">
          <img
            src="../imgs/one-group-dark.png"
            v-if="isDark"
            alt="1、开团/参团，2、邀请好友，3、成团抽奖，4、中奖发货"
          />
          <img src="../imgs/one-group.png" v-else alt="1、开团/参团，2、邀请好友，3、成团抽奖，4、中奖发货" />
        </div>
      </div>
      <div class="icon-ask"></div>
    </div>
    <v-os-popup container="body" title="拼团玩法" v-model="showPop" @close="showPop = false" :footerShow="false">
      <div class="groupon-rule-pop" v-html="grouponRuleInfo"></div>
    </v-os-popup>
  </div>
</template>

<script>
// 第三方包
import { mapState, mapGetters, mapActions } from 'vuex'
import { app } from '@/utils'
// 组件
export default {
  name: 'GroupRundown',
  components: {},
  computed: {
    ...mapState('detailv3', ['skuInfo']),
    ...mapGetters('detailv3', ['goodsType', 'skuId']),
    grouponRuleInfo() {
      return this.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityGroupon?.grouponRuleDesc || ''
    }
  },
  data() {
    return {
      // 是否展示参数弹层
      showPop: false,
      isDark: app.getColorScheme()
    }
  },
  methods: {
    ...mapActions('detailv3', ['savePreFocusElByEvent']),
    showGroup(e) {
      this.savePreFocusElByEvent(e)
      this.showPop = true
    }
  }
}
</script>

<style scoped lang="scss" src="./index.scss"></style>
<style lang="scss" scoped src="../../../index/dark-popup.scss"></style>
